import { useIntersection } from './useIntersection.tsx';
import dispatchTrackingEvent from '../services/TrackingService.ts';

export default function useImpression<T extends HTMLElement>(
  raisedBy: string,
  creativeSlot: string,
  ecommerce: {
    promotionId: string;
    promotionName: string;
    creativeName: string;
  }
) {
  const { elementRef } = useIntersection<T>({
    threshold: 0.5,
    onFirstInteraction: () => {
      const { promotionId, promotionName, creativeName } = ecommerce;

      // ignore tracking events with no useful data
      if (!promotionId && !promotionName && !creativeName) {
        return;
      }

      dispatchTrackingEvent({
        event: 'view_promotion',
        event_raised_by: raisedBy,
        ecommerce: {
          promotion_id: promotionId,
          promotion_name: promotionName,
          creative_slot: creativeSlot,
          creative_name: creativeName
        }
      });
    }
  });

  return elementRef;
}
